import { useLeadsContainerStore, useLeadsSheetStore } from "../../../../../stores/LeadsStore";
import { ActionIcon, Checkbox, Indicator, Stack, Tooltip } from "@mantine/core";
import {
  IconArrowDown,
  IconArrowUp,
  IconBuildingCommunity,
  IconX,
} from "@tabler/icons-react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";

const LeadSheetController = () => {
  const lang = useLanguage((s) => s.language);
  const prevProspect = useLeadsSheetStore((s) => s.prevProspect);
  const nextProspect = useLeadsSheetStore((s) => s.nextProspect);
  const handleClose = useLeadsSheetStore((s) => s.handleClose);
  const index = useLeadsSheetStore((s) => s.index);
  const currentContainer = useLeadsSheetStore((s) => s.currentContainer);
  const loading = useLeadsSheetStore((s) => s.loading);
  const orgProspected = useLeadsSheetStore((s) => s.orgProspected);
  const current = useLeadsSheetStore((s) => s.current);
  const openedOrg = useLeadsSheetStore((s) => s.openedOrg);
  const setOpenedOrg = useLeadsSheetStore((s) => s.setOpenedOrg);
  const selectedIds = useLeadsContainerStore((s) => s.selectedIds);
  const setSelectedIds = useLeadsContainerStore((s) => s.setSelectedIds);
  const selectedColumns = useLeadsContainerStore((s) => s.selectedColumns);
  const unselectedIds = useLeadsContainerStore((s) => s.unselectedIds);
  const setUnselectedIds = useLeadsContainerStore((s) => s.setUnselectedIds);


  const navigate = useNavigate();
  const handleSheetClose = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete("contact");
    searchParams.delete("container");
    searchParams.delete("index");

    navigate(
      {
        pathname: location.pathname,
        search: searchParams.toString(),
      },
      { replace: false }
    );
    handleClose();
  };

  const handleNext = () => {
    nextProspect();

    const searchParams = new URLSearchParams(location.search);
    searchParams.set("index", index + 1);
    let nextId = currentContainer.items[index + 1]?.id;
    searchParams.set("contact", nextId);

    navigate({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  };

  const handlePrev = () => {
    prevProspect();

    const searchParams = new URLSearchParams(location.search);
    searchParams.set("index", index - 1);
    let nextId = currentContainer.items[index - 1]?.id;
    searchParams.set("contact", nextId);

    navigate({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  };


  const handleCheck = useCallback(
    (e) => {
      let newValue = e.target.checked;

      // Checking
      if (newValue === true) {
        if (selectedColumns.includes(currentContainer?.id)) {
          let newSelection = { ...unselectedIds };
          newSelection[currentContainer?.id] = newSelection[currentContainer?.id]?.filter(
            (x) => x !== current.id
          );
          setUnselectedIds(newSelection);
        } else {
          let newSelection = { ...selectedIds };
          newSelection[currentContainer?.id] = [
            ...(newSelection[currentContainer?.id] || []),
            current.id,
          ];
          setSelectedIds(newSelection);
        }
      }
      // Unchecking
      else {
        if (selectedColumns.includes(currentContainer?.id)) {
          let newSelection = { ...unselectedIds };
          newSelection[currentContainer?.id] = [
            ...(newSelection[currentContainer?.id] || []),
            current.id,
          ];
          setUnselectedIds(newSelection);
        } else {
          let newSelection = { ...selectedIds };
          newSelection[currentContainer?.id] = newSelection[currentContainer?.id]?.filter(
            (x) => x !== current.id
          );
          setSelectedIds(newSelection);
        }
      }
    },
    [
      selectedIds,
      unselectedIds,
      selectedColumns,
      setSelectedIds,
      setUnselectedIds,
      currentContainer?.id,
      current?.id,
    ]
  );

  const getChecked = useCallback(() => {
    const selected = Object.values(selectedIds).flatMap((x) => x);
    const notSelected = Object.values(unselectedIds).flatMap((x) => x);
    if (selectedColumns.includes(currentContainer?.id)) {
      if (notSelected.includes(current.id)) {
        return false;
      }
      return true;
    }
    if (selected.includes(current.id)) {
      return true;
    }
    return false;
  }, [selectedIds, unselectedIds, selectedColumns, currentContainer?.id, current?.id]);

  return (
    <Stack mt={12} mx={12} gap={"xl"}>
      <ActionIcon
        variant="subtle"
        size={"lg"}
        radius={"md"}
        onClick={handleSheetClose}
      >
        <IconX size={20} />
      </ActionIcon>

      <ActionIcon.Group orientation="vertical">
        <ActionIcon
          variant="filled"
          size={"lg"}
          radius={"md"}
          disabled={loading || index <= 0}
          onClick={handlePrev}
        >
          <IconArrowUp size={20} />
        </ActionIcon>

        <ActionIcon
          variant="filled"
          size={"lg"}
          radius={"md"}
          disabled={loading || index >= currentContainer?.items?.length - 1}
          onClick={handleNext}
        >
          <IconArrowDown size={20} />
        </ActionIcon>
      </ActionIcon.Group>

      <Checkbox
        checked={getChecked()}
        onChange={handleCheck}
        size="lg"
        color={currentContainer?.color ? `#${currentContainer?.color}` : "primary"}
        radius={"md"}
        ml={1}
      />
      <Tooltip label={lang.prm.details.view_same_org} position="right">
        <Indicator offset={8} color="red" disabled={!orgProspected} size={12}>
          <ActionIcon
            variant="filled"
            size={"lg"}
            radius={"md"}
            disabled={
              loading ||
              !current?.properties?.find(
                (x) => x.identifier_placeholder === "%company%"
              )
            }
            onClick={() => setOpenedOrg(!openedOrg)}
          >
            <IconBuildingCommunity size={20} />
          </ActionIcon>
        </Indicator>
      </Tooltip>
    </Stack>
  );
};

export default LeadSheetController;
